import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CurrencyModule, PriceComponent } from "@hermes/aphrodite/price";
import { ImageResizerModule } from "@hermes/fragments/image-resizer";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { ProductCardComponent } from "./product-card.component";

@NgModule({
    imports: [
        CommonModule,
        ImageResizerModule,
        PriceComponent,
        CurrencyModule,
        SrOnlyNoSnippetDirective,
    ],
    declarations: [ProductCardComponent],
    exports: [ProductCardComponent],
})
export class ProductCardModule {}
